import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Users } from 'lucide-react';
import type { TeamAvailabilityProgress } from '@/types/tournament-round.model';

interface AvailabilityProgressPanelProps {
  progress: TeamAvailabilityProgress[];
}

/** Panel with each team's availability submission progress. */
export function AvailabilityProgressPanel({ progress }: AvailabilityProgressPanelProps) {
  if (progress.length === 0) {
    return null;
  }

  const loadedCount = progress.filter((p) => p.loaded).length;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-base">
          <Users className="h-4 w-4 text-blue-600" />
          Disponibilidad de equipos
          <span className="ml-auto text-sm font-normal text-muted-foreground">
            {loadedCount}/{progress.length} cargaron
          </span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="divide-y">
          {progress.map((team) => (
            <div key={team.registrationId} className="flex items-center justify-between py-2">
              <span className="text-sm font-medium text-gray-800">{team.teamName}</span>
              <div className="flex items-center gap-2">
                {team.loaded ? (
                  <Badge variant="outline" className="border-green-200 bg-green-50 text-green-700 text-xs">
                    Cargó ({team.slotsCount} horario{team.slotsCount !== 1 ? 's' : ''})
                  </Badge>
                ) : (
                  <Badge variant="outline" className="border-red-200 bg-red-50 text-red-700 text-xs">
                    No cargó
                  </Badge>
                )}
              </div>
            </div>
          ))}
        </div>
        <p className="mt-3 text-xs text-muted-foreground">
          A los equipos que no carguen disponibilidad el sistema les asignará cualquier horario libre.
        </p>
      </CardContent>
    </Card>
  );
}
